import ApiClientInvestment from './apiClientInvestment'
import { useAuthStore } from './authStore'

// Vytvoríme jedinú inštanciu ApiClientInvestment pre celú aplikáciu
const apiClientInvestment = new ApiClientInvestment()

// Pri prvom načítaní aplikácie nastavíme token z `authStore`
const auth = useAuthStore.getState().auth
apiClientInvestment.setAuthToken(auth?.token ?? null)

// Počúvame na zmeny v `authStore` a aktualizujeme `apiClientInvestment`
useAuthStore.subscribe((state) => {
  apiClientInvestment.setAuthToken(state.auth?.token ?? null)
})

/**
 * Hook to get the api instance (Nest investment API, apiClientInvestment).
 * Synchronizuje token zo store pri každom renderi, čím sa vyhne race condition
 * keď hasAuthToken je už true, ale client ešte nemal token.
 */
export function useApiClientInvestment() {
  const auth = useAuthStore((state) => state.auth)
  // Sync token pred vrátením - zaručí, že client má token keď ho komponent použije
  apiClientInvestment.setAuthToken(auth?.token ?? null)
  return apiClientInvestment.apiInstance
}
